<template>
  <label :for="option.id">
    <span class="tile-title"><span v-bind:class="option.cssClass" class="icon"></span>{{ option.name }}</span>
    <span class="body-text">
        <span>{{ getDeliveryDescription() }}</span>
        <br/>
        <span v-if="isInFlyin">{{ this.option.flyIn.time }}</span>
    </span>
    <span class="delivery-price">{{ option.price }}</span>
  </label>
</template>
<script src="./home-delivery-option-tile.js"/>
